export const presentationTypeEnum = {
    cover: 'Cover',
    contain: 'Contain'
};